import useHasAccess from '../hooks/use-has-access.hook';

interface HasAccessViewProps {
  children: any;
  onlyRoot?: boolean;
  view?: string[];
}

const HasAccessView = ({ children, view, onlyRoot }: HasAccessViewProps) => {
  const { isAllowed } = useHasAccess({ view, onlyRoot });
  return isAllowed ? children : null;
};

export default HasAccessView;
